import { useState } from 'react';
import { z } from 'zod';
import { emailSchema, passwordSchema } from '../schema';

export const useFormValidation = () => {
  const [emailValidationMessages, setEmailValidationMessages] = useState<
    string[]
  >([]);
  const [passwordValidationMessages, setPasswordValidationMessages] = useState<
    string[]
  >([]);

  const validateEmail = (value: string) => {
    try {
      emailSchema.parse(value);
      setEmailValidationMessages([]);
    } catch (e) {
      if (e instanceof z.ZodError) {
        setEmailValidationMessages(e.flatten().formErrors);
      }
    }
  };

  const validatePassword = (value: string) => {
    try {
      passwordSchema.parse(value);
      setPasswordValidationMessages([]);
    } catch (e) {
      if (e instanceof z.ZodError) {
        setPasswordValidationMessages(e.flatten().formErrors);
      }
    }
  };

  return {
    emailValidationMessages,
    passwordValidationMessages,
    validateEmail,
    validatePassword
  };
};
